import { lazy } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import Layouts from "../layouts/index";

const ProductList = lazy(() => import("../pages/product/ProductList"));
const ProductAdd = lazy(() => import("../pages/product/ProductAdd"));
const ProductView = lazy(() => import("../pages/product/ProductView"));
const ProductLayouts = lazy(() => import("../pages/product/Layouts"));
const AssociateProcessPage = lazy(
  () => import("../pages/workflow/AssociateProcessPage"),
);
const InitiateProcessPage = lazy(
  () => import("../pages/workflow/InitiateProcessPage"),
);
const Documents = lazy(() => import("../pages/product/documents"));
const RecordMetadata = lazy(() => import("../pages/product/RecordMetadata"));
const EditRecordMetadata = lazy(
  () => import("../pages/product/RecordMetadata/EditRecordMetadata"),
);

const GlobalSearchList = lazy(() => import("../pages/globalSearch/index"));

const DynamicListPage = lazy(() => import("../pages/product/dynamic/ListPage"));

const DynamicViewPage = lazy(() => import("../pages/product/dynamic/ViewPage"));

const DynamicEditPage = lazy(() => import("../pages/product/dynamic/EditPage"));
const LinkItemPage = lazy(() => import("../pages/product/linkItems"));
const GroupTreePage = lazy(
  () => import("../pages/product/groupTree/GroupTreePage"),
);

const routesForm = [
  {
    path: "/*",
    element: <Navigate to="/products" />,
  },
  {
    path: "/global-search-list",
    element: <Layouts />,
    children: [
      {
        path: "/global-search-list",
        element: <GlobalSearchList />,
      },
    ],
  },
  {
    path: "/home",
    element: <Layouts />,
    /* children: [
      {
        path: "/home",
        element: <Home />,
      },
    ], */
  },
  {
    path: "/products",
    element: <Layouts />,
    children: [
      {
        path: "",
        element: <ProductList />,
      },
      {
        path: "associate-process/:productId/:recordId",
        element: <AssociateProcessPage />,
      },
      {
        path: "initiate-process/:productId/:processAssociationId/:recordId",
        element: <InitiateProcessPage />,
      },
      {
        path: "/products/add-product",
        element: <ProductLayouts />,
        children: [
          {
            path: "",
            element: <ProductAdd />,
          },
        ],
      },
      {
        path: "edit-product/:productId",
        element: <ProductLayouts />,
        children: [
          // {
          //   path: "",
          //   element: <EditProduct />,
          // },
          {
            path: "",
            element: <ProductAdd />,
          },
          {
            path: ":menuId",
            element: <DynamicListPage />,
          },
          {
            path: ":menuId/view/:id",
            element: <DynamicViewPage />,
          },
          {
            path: ":menuId/edit/:id",
            element: <DynamicEditPage />,
          },
          {
            path: ":menuId/add",
            element: <DynamicEditPage />,
          },
          {
            path: ":menuId/linkItems",
            element: <LinkItemPage />,
          },
          {
            path: "tree/:groupId",
            element: <GroupTreePage />,
          },
          {
            path: "documents",
            element: <Documents />,
          },
          {
            path: "recordmetadata",
            element: <RecordMetadata />,
          },
          {
            path: "recordmetadata/addmetadata/:docId",
            element: <EditRecordMetadata />,
          },
          {
            path: "recordmetadata/editmetadata/:docId/:id",
            element: <EditRecordMetadata />,
          },
          {
            path: "recordmetadata/viewmetadata/:docId/:id",
            element: <EditRecordMetadata />,
          },
          // {
          //   path: "include-product",
          //   element: <IncludeProductList />,
          // },
          // {
          //   path: ":menuId",
          //   element: <CommonSubModule />,
          // },
          // {
          //   path: ":menuId/add",
          //   element: <AddPackageCommon />,
          // },
          // {
          //   path: ":menuId/edit/:id",
          //   element: <AddPackageCommon />,
          // },
          // {
          //   path: ":menuId/view/:id",
          //   element: <AddPackageCommon />,
          // },
        ],
      },
      {
        path: "view-product/:productId",
        element: <ProductLayouts />,
        children: [
          {
            path: "",
            element: <ProductView />,
          },
          {
            path: ":menuId",
            element: <DynamicListPage />,
          },
          {
            path: ":menuId/view/:id",
            element: <DynamicViewPage />,
          },
          {
            path: ":menuId/edit/:id",
            element: <DynamicEditPage />,
          },
          {
            path: ":menuId/add",
            element: <DynamicEditPage />,
          },
          {
            path: ":menuId/linkItems",
            element: <LinkItemPage />,
          },
          {
            path: "tree/:groupId",
            element: <GroupTreePage />,
          },
          {
            path: "documents",
            element: <Documents />,
          },
          {
            path: "recordmetadata",
            element: <RecordMetadata />,
          },
          {
            path: "recordmetadata/addmetadata/:docId",
            element: <EditRecordMetadata />,
          },
          {
            path: "recordmetadata/editmetadata/:docId/:id",
            element: <EditRecordMetadata />,
          },
          {
            path: "recordmetadata/viewmetadata/:docId/:id",
            element: <EditRecordMetadata />,
          },

          // {
          //   path: "include-product",
          //   element: <IncludeProductList />,
          // },
          // {
          //   path: ":menuId",
          //   element: <CommonSubModule />,
          // },
        ],
      },
    ],
  },
];

const Router = createBrowserRouter(routesForm);

export { Router };
